import { render, staticRenderFns } from "./ChangeBankingWage.vue?vue&type=template&id=09fb9fd4&scoped=true"
import script from "./ChangeBankingWage.vue?vue&type=script&lang=js"
export * from "./ChangeBankingWage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb9fd4",
  null
  
)

export default component.exports